import React from "react";
// React Table
import {Col, Container, Form, Row} from "react-bootstrap";
// Styled Components
import styled from "styled-components";

const CustomTd = styled.td`
  background-color: #eeeeee;
`;

const VistaEconomicos = ({ datosMision, datosIngresos }) => {
  // Comprueba si la misión es autofinanciada
  const esAutofinanciada = () => {
      return !(datosMision.stjIncome || datosMision.governmentIncome || datosMision.fundeoIncome || datosMision.donation || datosMision.otherIncome);

  };

  return (
    <Container>
      <Row>
        <Col>
          {esAutofinanciada() ? (
            <b>Esta misión está siendo autofinanciada</b>
          ) : (
            <>
              <b>Financiada por: </b>
              <Container>
                {datosMision?.stjIncome && (
                  <lu>
                    <li>STJ</li>
                  </lu>
                )}
                {datosMision?.governmentIncome && (
                  <lu>
                    <li>Gobierno</li>
                  </lu>
                )}
                {datosMision?.fundeoIncome && (
                  <lu>
                    <li>FUNDEO</li>
                  </lu>
                )}
                {datosMision?.otherIncome && (
                  <lu>
                    <li>Otros</li>
                  </lu>
                )}
                {datosMision?.donation && (
                  <lu>
                    <li>Donaciones</li>
                  </lu>
                )}
              </Container>
            </>
          )}
        </Col>
        {datosMision.type === "Obra" && (
          <Col>
            <b>Ingresos</b>
            {datosIngresos.length ? (
              <Container>
                <lu>
                  {datosIngresos.map((ingreso) => (
                    <li>{ingreso.type}</li>
                  ))}
                </lu>
              </Container>
            ) : (
              <p>Esta obra no tiene asignado un origen de ingresos actualmente.</p>
            )}
          </Col>
        )}
      </Row>
      <Row className="mt-2">
        <Col>
          <Form.Check custom label={"Contabilidad STJ"} checked={datosMision?.accounting} disabled />
        </Col>
      </Row>
    </Container>
  );
};

export default VistaEconomicos;
